import RepositoryFactory from '@/repository/RepositoryFactory';

const managerRepository = RepositoryFactory.manager;

/**
 * 設定画面サイドメニュー用コントローラー
 *
 * @description
 * - collapsibleの開閉状態をServiceで管理
 * - 全メニューアイテムの表示/非表示条件をコントローラーに集約
 *
 */
angular.module('inspinia').controller('localNaviServiceCtrl', [
  '$scope',
  '$state',
  'settingSidebarStateService',
  function ($scope, $state, settingSidebarStateService) {
    $scope.useDmt = false;
    managerRepository.memoriesBetaFacility
      .get('useDmt')
      .then((response) => {
        $scope.useDmt = response.data.isAvailable;
      })
      .catch(() => {
        $scope.useDmt = false;
      });
    /**
     * $scope.servicesやその他のオブジェクトがundefined/nullの場合でもエラーを防ぎ、
     * 適切なデフォルト値を返す。AngularJSの非同期データ読み込みやdigest cycleの
     * タイミング問題に対処する。
     */
    const safeData = (accessor, defaultValue = false) => {
      try {
        return accessor() ?? defaultValue;
      } catch {
        return defaultValue;
      }
    };

    // 初期表示時のみ実行、現在のルートに基づいて展開メニューの開閉状態を設定
    settingSidebarStateService.initializeFromRoute($state);

    // serviceオブジェクトを直接スコープに割り当て（状態を保持するため）
    $scope.sidebarState = settingSidebarStateService;

    // サービス情報が利用可能になったら各メニュー項目の表示状態を更新
    const handleServicesChange = () => {
      if ($scope.services && $scope.services.attributes && $scope.system && $scope.services.plan_id) {
        const isBasicPlan = $scope.isBasicServicePlanByPlanId($scope.services.plan_id);
        settingSidebarStateService.updateAllMenuVisibility($scope.services, $scope.system, isBasicPlan);
      }
    };

    $scope.$watchGroup(
      [
        'services.plan_id',
        'services.open_date',
        'services.attributes.billing_system',
        'services.attributes.data_security_use',
        'services.attributes.billing_use',
        'services.attributes.use_school_free_plan',
      ],
      handleServicesChange
    );

    // コールバック関数
    $scope.onDailyBoardToggle = (isOpen) => {
      settingSidebarStateService.setDailyBoardOpen(isOpen);
    };

    $scope.onMemberToggle = (isOpen) => {
      settingSidebarStateService.setMemberOpen(isOpen);
    };

    $scope.onBillingGroupToggle = (isOpen) => {
      settingSidebarStateService.setBillingGroupOpen(isOpen);
    };

    // サイドメニュー項目の表示条件
    $scope.menuItems = {
      // 連絡帳製本
      showDailyBooks: () =>
        safeData(
          () =>
            $scope.isBasicServicePlanByPlanId($scope.services.plan_id) &&
            $scope.services.attributes.photo_use == $scope.system.FLAG_ON &&
            !$scope.isLgwan() &&
            !$scope.isShoChuKo($scope.services.kind)
        ),
      // 所在確認アラート
      showWhereaboutsCheck: () =>
        safeData(
          () =>
            $scope.isBasicServicePlanByPlanId($scope.services.plan_id) &&
            $scope.isYouho($scope.services.kind) &&
            !$scope.isLgwan() &&
            $scope.services.attributes.attendance_use == $scope.system.FLAG_ON
        ),

      // 日誌
      hideComments: () => safeData(() => !$scope.isBasicServicePlanByPlanId($scope.services.plan_id), true),

      // 健康チェック
      hideDailyCheck: () =>
        safeData(
          () =>
            !$scope.isBasicServicePlanByPlanId($scope.services.plan_id) ||
            !$scope.isYouho($scope.services.kind) ||
            $scope.services.attributes.health_check_use != $scope.system.FLAG_ON,
          true
        ),

      // 食事チェック・給食管理
      showMeal: () =>
        safeData(
          () =>
            $scope.isBasicServicePlanByPlanId(parseInt($scope.services.plan_id, 10)) &&
            !$scope.isLgwan() &&
            !$scope.isShoChuKo($scope.services.kind)
        ),

      // お知らせ一斉配信
      showTopics: () =>
        safeData(
          () =>
            parseInt($scope.services.attributes.use_school_free_plan, 10) === $scope.system.FLAG_ON ||
            $scope.isBasicServicePlanByPlanId($scope.services.plan_id)
        ),

      // 行事予定
      hideSchedule: () =>
        safeData(
          () =>
            !$scope.isBasicServicePlanByPlanId($scope.services.plan_id) ||
            $scope.services.attributes.schedule_use != $scope.system.FLAG_ON,
          true
        ),

      // 登降園管理
      hideAttendance: () =>
        safeData(
          () =>
            !$scope.isBasicServicePlanByPlanId($scope.services.plan_id) ||
            $scope.services.attributes.attendance_use != $scope.system.FLAG_ON,
          true
        ),

      // 出退勤管理
      hideAdministratorAttendance: () =>
        safeData(
          () =>
            !$scope.isBasicServicePlanByPlanId($scope.services.plan_id) ||
            $scope.services.attributes.attendance_use != $scope.system.FLAG_ON,
          true
        ),

      // シフト管理
      showShift: () =>
        safeData(() => $scope.services.attributes.shift_v2_use == $scope.system.FLAG_ON && !$scope.isLgwan()),

      // 請求管理＞詳細設定
      showCharge: () => safeData(() => $scope.services.attributes.billing_use == $scope.system.FLAG_ON),

      // 請求管理＞基本設定
      showBillingBasic: () => settingSidebarStateService.isBillingBasicVisible(),

      // 記録と計画
      showReports: () =>
        safeData(
          () =>
            $scope.services.attributes.report_use == $scope.system.FLAG_ON &&
            ['361'].indexOf($scope.my.current_service_id ? $scope.my.current_service_id : $scope.my.service_id) === -1
        ),

      // 保育ドキュメンテーション
      showDocumentations: () => safeData(() => $scope.services.attributes.documentation_use == $scope.system.FLAG_ON),

      // 園児台帳
      hideMember: () => safeData(() => !$scope.isBasicServicePlanByPlanId($scope.services.plan_id), true),

      // 発達記録
      showDevelopment: () =>
        safeData(
          () =>
            $scope.isBasicServicePlanByPlanId(parseInt($scope.services.plan_id, 10)) &&
            parseInt($scope.services.attributes.health_check_use, 10) === $scope.system.FLAG_ON &&
            $scope.isYouho($scope.services.kind)
        ),

      // バス運行管理
      showBusLocation: () =>
        safeData(
          () =>
            ($scope.services.attributes.bus_location_use == $scope.system.FLAG_ON ||
              $scope.services.attributes.bus_location_use_only_manager == $scope.system.FLAG_ON) &&
            !$scope.isLgwan() &&
            !$scope.isL4A()
        ),

      // 請求管理＞横浜市請求
      showYokohama: () =>
        safeData(
          () =>
            $scope.services.attributes.billing_yokohama_use == $scope.system.FLAG_ON &&
            !$scope.isLgwan() &&
            !$scope.isL4A()
        ),

      // データダウンロード（GK）
      showGkDownload: () =>
        safeData(
          () =>
            ($scope.my.current_service_id == 8 || $scope.my.current_service_id == 3812) &&
            !$scope.isLgwan() &&
            !$scope.isL4A()
        ),

      // データダウンロード（港区）
      showMinatoDownload: () =>
        safeData(
          () =>
            (($scope.my.current_service_id == 8 || $scope.my.current_service_id == 17) && $scope.isLgwan()) ||
            (($scope.my.current_service_id == 8 || $scope.my.current_service_id == 31612) &&
              !$scope.isLgwan() &&
              !$scope.isL4A())
        ),

      // IPアドレス制限
      showIpRestriction: () => settingSidebarStateService.isIpRestrictionVisible(),

      // 口座情報
      showBankAccount: () => true,

      // 家庭からの連絡
      showParentContacts: () => settingSidebarStateService.isParentContactsVisible(),

      // 展開メニューグループの表示条件

      // デイリーボードグループ（子項目のいずれかが表示される場合のみ表示）
      showDailyBoardGroup: () => {
        return (
          $scope.menuItems.showWhereaboutsCheck() ||
          !$scope.menuItems.hideComments() ||
          !$scope.menuItems.hideDailyCheck() ||
          $scope.menuItems.showMeal()
        );
      },

      // 園児台帳グループ（子項目のいずれかが表示される場合のみ表示）
      showMemberGroup: () => {
        return !$scope.menuItems.hideMember() || $scope.menuItems.showDevelopment();
      },

      // 請求管理グループ（子項目のいずれかが表示される場合のみ表示）
      showBillingGroup: () => {
        return $scope.menuItems.showBillingBasic() || $scope.menuItems.showCharge() || $scope.menuItems.showYokohama();
      },
    };
  },
]);
